module.exports = __webpack_public_path__ + "sunsemweb/img/sbanner.6b870975.png";